/**
 * Default entry point — every module compiled in, config fetched at runtime.
 * This is the `main` bundle, and the fallback the CDN serves whenever the site
 * is not identified.
 *
 * Variant entry points live in `src/entries/`.
 */

import { bootstrap, KueezSDK, type KueezSDKType } from './bootstrap';
import { ALL_MODULES } from './modules/all';
import {
  getFooterCopyrights,
  getSettingUrl,
  getSiteLinks,
  getWebsiteFavicon,
  getWebsiteHomeUrl,
  getWebsiteLogo,
} from './core/branding';
import { escapeHtml, formatText } from './util/html';

/**
 * Publisher-chrome accessors and the markup helpers that go with them, attached
 * here rather than in `bootstrap.ts`: a sealed variant runs on a site that
 * already renders its own chrome, so it has no use for these and should not
 * carry them.
 */
const mainSurface = {
  getWebsiteLogo,
  getFooterCopyrights,
  getWebsiteFavicon,
  getWebsiteHomeUrl,
  getSettingUrl,
  getSiteLinks,
  escapeHtml,
  formatText,
};
Object.assign(KueezSDK, mainSurface);

bootstrap(ALL_MODULES);

export type KueezSDKMainType = KueezSDKType & typeof mainSurface;
export type { KueezSDKType };
export default KueezSDK as KueezSDKMainType;
